import { render, staticRenderFns } from "./UserViewer.vue?vue&type=template&id=28560051&scoped=true&"
import script from "./UserViewer.vue?vue&type=script&lang=js&"
export * from "./UserViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28560051",
  null
  
)

export default component.exports